<template>
  <block-title
    class="order-overview overview order-statistics"
    :show-line="false"
    title="近七日数据统计"
  >
    <a-tabs
      v-model="tabActive"
      class="overview-tabs"
      @change="getStatistics"
    >
      <a-tab-pane
        v-for="item in tabList"
        :key="item.value"
        :tab="item.label"
      />
    </a-tabs>
    <el-row class="information">
      <el-col :span="14">
        <div id="statistics" class="charts" />
      </el-col>
      <el-col :span="10" class="statistics-top">
        <h3>门店订单排名</h3>
        <!-- 返回的数据没有单独的key -->
        <template v-if="topList.length">
          <div
            v-for="(item, index) in topList"
            :key="index"
            class="top-list flex justify-between"
          >
            <div class="top-list-name">
              <span class="top-num">{{index+1}}</span>
              {{item.station_name}}
            </div>
            <div class="top-list-num">
              <span>{{item.station_order_cnt}}</span>
              单
            </div>
          </div>
        </template>
        <empty v-else class="empty-static" />
      </el-col>
    </el-row>
  </block-title>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import moment from 'moment'
import base from '@/api/base'
import Empty from './Empty.vue'
import { orderStatisticsData } from '../constant'
import { getOrderCntByDay, getStationOrderCnt } from '../api'
// 引入 ECharts 主模块
const echarts = require("echarts");

const emphasisStyle = {
  itemStyle: {
    shadowBlur: 10,
    shadowColor: 'rgba(106, 133, 161, 0.79)'
  }
};

export default {
  name: 'OrderStatistics',
  components: {
    BlockTitle,
    Empty
  },
  props: {
    isDemo: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      tabActive: '1',
      myChart: {},
      tabList: [
        {
          label: '纯运输',
          value: '1'
        },
        {
          label: '仓配一体',
          value: '0'
        }
      ],
      echartOption: {
        title: {
          text: '订单统计'
        },
        tooltip: {
          // trigger: 'axis',
          // axisPointer: {
          //   type: 'shadow'
          // },
          formatter (params) {
            const param = params.data || {};
            return `
            <div class="chats-tooltip">
              <div class="order-total">
                总订单:
                <span>${param.total}</span>
              </div>
              <div class="chats-tooltip-status">
                进行中:
                <span>${param.process}</span>
              </div>
              <div class="chats-tooltip-status done-status">
                已完成:
                <span>${param.complete}</span>
              </div>
            </div>
            `;
          }
        },
        color:['#37C598','#4F97E5'],
        legend: {
          right: 0,
          data: ['进行中', '已完成']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [this.getDay(6), this.getDay(5), this.getDay(4), this.getDay(3), this.getDay(2), this.getDay(1), this.getDay()],
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '进行中',
            type: 'bar',
            stack: 'one',
            barWidth : 28,
            emphasis: emphasisStyle,
            data: [],
          },
          {
            name: '已完成',
            type: 'bar',
            stack: 'one',
            barWidth : 28,
            emphasis: emphasisStyle,
            data: [],
          },
        ]
      },
      topList: [],
    }
  },
  mounted() {
    this.myChart = echarts.init(document.getElementById('statistics'));
    this.getStatistics();
  },
  methods: {
    getDay(i = 0) {
      return `${moment().subtract(i, "days").format('DD')}日`
    },
    async getStatistics() {
      if(this.isDemo) {
        const { echartData } = orderStatisticsData;
        const {echartOption} = this;
        const {processing, complete} = echartData[this.tabActive]
        echartOption.series[0].data = processing
        echartOption.series[1].data = complete
        this.echartOption = echartOption
        this.echartInit()
        const res = await base.getDictionary({
          status: 1,
          type: 'board_store_rank'
        })
        this.topList = res.map(item => {
          return {
            station_name: item.dictionaryName,
            station_order_cnt: item.dictionaryCode
          }
        })
        return
      }
      this.topList = []
      const {projectIds,creditCode,customers,customerCode}=this.$store.state.user
      const params = {
        startTime: moment().subtract(6, "days").startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        uOrderType: this.tabActive, // U订单类型，1-运输，0-仓配
      }
      if(creditCode){
        params.customerCodes=customers.map(item=>item.customerCode)
        params.projectIds=projectIds
      }else{
        params.customerCode=customerCode
        params.projectIds=projectIds
      }
      const orderCnt = await getOrderCntByDay(params)
      const processing = []
      const complete = []
      orderCnt.forEach(item => {
        processing.push({
          value: item.processing_u_order_cnt,
          total: item.total_u_order_cnt,
          process: item.processing_u_order_cnt,
          complete: item.complete_u_order_cnt,
        })
        complete.push({
          value: item.complete_u_order_cnt,
          total: item.total_u_order_cnt,
          process: item.processing_u_order_cnt,
          complete: item.complete_u_order_cnt,
        })
      })
      const { echartOption } = this
      echartOption.series[0].data = processing
      echartOption.series[1].data = complete
      this.echartOption = echartOption
      this.echartInit()
      this.topList = await getStationOrderCnt(params)
    },
    echartInit() {
      this.myChart.setOption(this.echartOption)
    },
  }
}
</script>

<style lang="less" scoped>
.order-statistics {
  .empty-static {
    text-align: center;
  }
  .overview-tabs {
    /deep/ .ant-tabs-nav-scroll {
      margin-left: 32px;
      .ant-tabs-ink-bar  {
        height: 4px;
      }
    }
  }
  .information {
    display: flex;
    padding: 8px 32px 0 32px;
    .charts {
      height: 430px;
      padding-right: 79px;
    }
    .statistics-top {
      padding-left: 81px;
      border-left: 1px solid #EBEDF0;
      h3 {
        margin-bottom: 16px;
      }
      .top-list {
        height: 48px;
        line-height: 48px;
        .top-list-name {
          width: 55%;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          white-space: nowrap;
          .top-num {
            display: inline-block;
            width: 24px;
            height: 24px;
            margin-right: 16px;
            color: #06B880;
            border: 1px solid #06B880;
            border-radius: 50%;
            text-align: center;
            vertical-align: middle;
            line-height: 24px;
          }
        }
        .top-list-num {
          span {
            color: #171717;
            font-weight: 500;
            font-size: 16px;
          }
        }
      }
      .top-list:nth-of-type(1), .top-list:nth-of-type(2), .top-list:nth-of-type(3) {
        .top-num {
          background: #029869;
          border: 1px solid #029869;
          color: #fff;
        }
      }
      .top-list:nth-of-type(2) {
        .top-num {
          background: #06B880;
        }
      }
      .top-list:nth-of-type(3) {
        .top-num {
          background: #37c598;
        }
      }
    }
  }
}
</style>
<style lang="less">
.chats-tooltip {
  width: 140px;
  padding: 0 2px;
  > div {
    span {
      float: right;
      font-weight: 500;
      color: #171717
    }
    &.chats-tooltip-status {
      &::before {
        content: '';
        display: inline-block;
        width: 10px;
        height: 10px;
        background: #37C598;
        border-radius: 50%;
      }
    }
    &.done-status {
      &::before {
        background: #4F97E5;
      }
    }
  }
  > div:nth-last-child(2) {
    margin: 8px 0;
  }
}
</style>